import SuccessPage from "./shared/SuccessPage";

export default function PasswordResetConfirmation() {
  return (
    <SuccessPage title="Password updated">
      Your new password is ready to use. You can return to Finn and sign in.
    </SuccessPage>
  );
}
